import React from 'react';
import {aulasVivas} from '../DataFiles/aulasVivas'

 
class AulasVivas extends React.Component {
    render(){
       

        return (
            <section className="aulas-vivas ptb-120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="partner-title platinum-sponsor">
                                <h3 className="lax" data-lax-preset="driftRight">Aulas Vivas</h3>
                            </div>
                        </div>
                    </div>



                    <div className="row">
                        
                        <div className="col-lg-8 col-sm-12">
                            <div className="mesa-redonda">
                                <p>Son pequeñas puertas a diferentes <b>experiencias educativas</b>, que pretenden inspirar y dar la posibilidad de crear contactos para intercambios futuros. </p>
                                <p>Se expondrán en diferentes formatos multimedia y/o carteles diferentes proyectos educativos:</p>
                            </div>
                            <hr/>
                            <div className='mesa-redonda'>
                                <ol>

                                    {aulasVivas.map(av=>(
                                    <li>
                                        <b>
                                            {av.name} 
                                        </b>
                                            {av.description}
                                    </li>
                                    ))}                                       

                                </ol>
                            </div>
                        </div>
                    </div>
               

                    <div className="row">
                        <div className="col-lg-8 col-sm-12">
                       
                        </div>
                    </div>

               
                </div>  


                       
            </section>
        );
    }
}
 
export default AulasVivas;